"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));
/**
 *
 * @param cells - number will mean that all cells have same size,
 *      otherwise string will give full option to configure
 */


var getGridTemplate = function getGridTemplate(cells) {
  if (cells !== undefined) {
    if (typeof cells === 'string') {
      return cells;
    } else {
      var counts = [];

      for (var index = 0; index < cells; index++) {
        counts.push('auto');
      }

      return counts.join(' ');
    }
  }

  return 'auto';
};

var setGap = function setGap(gap, defaultMargin) {
  switch (typeof gap) {
    case 'boolean':
      return defaultMargin;

    case 'string':
      return gap;

    default:
      return 0;
  }
};

exports.StyledGridContainer = styled_components_1.default.div(function (props) {
  return {
    alignItems: props.alignItems || '',
    alignContent: props.alignContent || '',
    display: 'grid',
    gridAutoFlow: props.gridFlow || '',
    gridGap: setGap(props.rowGap, props.theme.component.margin) + " " + setGap(props.colGap, props.theme.component.margin),
    gridTemplateColumns: getGridTemplate(props.cols),
    gridTemplateRows: getGridTemplate(props.rows),
    justifyContent: props.justifyContent || '',
    justifyItems: props.justifyItems || '',
    placeItems: props.placeItems || ''
  };
});
exports.default = exports.StyledGridContainer;